import React, { useState } from 'react';
import './Projects.css';

const projects = [
  {
    id: 1,
    title: 'Modern Commercial Building',
    category: 'commercial',
    location: 'Dar es Salaam',
    value: '£850K',
    image: '/images/projects/commercial-project-1.jpeg',
    description: 'Complete commercial development with modern façade and paved courtyard'
  },
  {
    id: 2,
    title: 'Glass Partition Office',
    category: 'commercial',
    location: 'Dar es Salaam',
    value: '£320K',
    image: '/images/projects/glass-partitions.jpeg',
    description: 'Contemporary office interior with full glass partition walls'
  },
  {
    id: 3,
    title: 'Modern Residential Villa',
    category: 'residential',
    location: 'Dar es Salaam',
    value: '£480K',
    image: '/images/projects/residential-modern.jpeg',
    description: 'Modern villa with glass railings and contemporary finishes'
  },
  {
    id: 4,
    title: 'Luxury Bathroom Renovation',
    category: 'renovation',
    location: 'Dar es Salaam',
    value: '£45K',
    image: '/images/projects/bathroom-project.jpeg',
    description: 'Complete bathroom renovation with glass shower enclosure'
  },
  {
    id: 5,
    title: 'Commercial Complex',
    category: 'commercial',
    location: 'Dar es Salaam',
    value: '£1.2M',
    image: '/images/projects/commercial-project-2.jpeg',
    description: 'Large commercial complex with brick paving and modern design'
  },
  {
    id: 6,
    title: 'Premium Window Installation',
    category: 'renovation',
    location: 'Dar es Salaam',
    value: '£65K',
    image: '/images/projects/window-frames.jpeg',
    description: 'Custom wooden window frames with marble finish exterior'
  }
];

const categories = [
  { id: 'all', label: 'All Projects' },
  { id: 'residential', label: 'Residential' },
  { id: 'commercial', label: 'Commercial' },
  { id: 'renovation', label: 'Renovations' }
];

const Projects = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [hoveredProject, setHoveredProject] = useState(null);

  const filteredProjects = activeCategory === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeCategory);

  return (
    <section className="projects" id="projects">
      <div className="projects__container">
        <div className="projects__header">
          <div className="projects__header-left">
            <span className="section-label">Our Portfolio</span>
            <h2 className="section-title">
              Featured <span className="text-accent">Projects</span>
            </h2>
          </div>
          
          <div className="projects__filters">
            {categories.map(cat => (
              <button
                key={cat.id}
                className={`projects__filter ${activeCategory === cat.id ? 'projects__filter--active' : ''}`}
                onClick={() => setActiveCategory(cat.id)}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
        
        <div className="projects__grid">
          {filteredProjects.map((project, index) => (
            <div 
              className={`project-card ${hoveredProject === project.id ? 'project-card--hovered' : ''}`}
              key={project.id}
              onMouseEnter={() => setHoveredProject(project.id)}
              onMouseLeave={() => setHoveredProject(null)}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="project-card__image">
                <img src={project.image} alt={project.title} loading="lazy" />
                <div className="project-card__overlay">
                  <button className="project-card__btn">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
                    </svg>
                  </button>
                </div>
              </div>
              
              <div className="project-card__content">
                <div className="project-card__meta">
                  <span className="project-card__category">{project.category}</span>
                  <span className="project-card__value">{project.value}</span>
                </div>
                <h3 className="project-card__title">{project.title}</h3>
                <p className="project-card__description">{project.description}</p>
                <div className="project-card__location">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                  <span>{project.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="projects__cta">
          <button className="btn btn--outline-dark">
            View All Projects
            <svg className="btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 12h14M12 5l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Projects;

